import ConditionalRenderer from '@/components/ui/custom/ConditionalRenderer';
import {
  QuizActivityIcon,
  TextActivityIcon,
  VideoActivityIcon,
  TrueOrFalseIcon,
  HandDragging,
} from '@/components/icons';
import { ActivityTypeEnum } from '@/models/_deprecated/ActivityElement';
import { CodeBracketIcon } from '@heroicons/react/24/outline';
import { useTranslation } from 'react-i18next';

type QuestionIconProps = {
  type: ActivityTypeEnum;
  hideText?: boolean;
};

export default function QuestionIcon({ type, hideText }: QuestionIconProps) {
  const { t } = useTranslation('translation', {
    keyPrefix: 'activity',
  });

  type IconQuestion = {
    icon: JSX.Element;
    text: string;
  };

  const icons: Record<ActivityTypeEnum, IconQuestion> = {
    [ActivityTypeEnum.QUIZ]: {
      icon: <QuizActivityIcon />,
      text: t('quizLabel'),
    },
    [ActivityTypeEnum.TEXT]: {
      icon: <TextActivityIcon />,
      text: t('textLabel'),
    },
    [ActivityTypeEnum.VIDEO]: {
      icon: <VideoActivityIcon />,
      text: t('videoLabel'),
    },
    [ActivityTypeEnum.TRUE_OR_FALSE]: {
      icon: <TrueOrFalseIcon />,
      text: t('trueFalseLabel'),
    },
    [ActivityTypeEnum.DND_ORDENATION]: {
      icon: <HandDragging />,
      text: t('dragAndDropOrdenation'),
    },
    [ActivityTypeEnum.DND_POSITIONAL]: {
      icon: <HandDragging />,
      text: t('dragAndDropPositional'),
    },
    [ActivityTypeEnum.CODE]: {
      icon: <CodeBracketIcon />,
      text: t('codeLabel'),
    },
    [ActivityTypeEnum.CODE_EDITOR]: {
      icon: <CodeBracketIcon className="w-4" />,
      text: t('codeEditorLabel'),
    },
    [ActivityTypeEnum.BLOCK]: {
      icon: <CodeBracketIcon className="w-4" />,
      text: t('blockCodeLabel'),
    },
  };

  const info = icons[type];

  if (!info) return null;

  return (
    <section className="flex gap-4 items-center">
      {info.icon}
      <ConditionalRenderer condition={!hideText}>
        {info.text}
      </ConditionalRenderer>
    </section>
  );
}
